export const getVyEnv = () => window.__vyEnv || "unknown";

export const getDatadogConfig = () => {
  const config = window.__datadogConfig;
  const { applicationId, clientToken, service } = config ?? {};

  if (!applicationId || !clientToken || !service) {
    return null;
  }

  return { applicationId, clientToken, service };
};
